import { useApiSubmit } from '@hooks/use-api-submit';
import type { IApiSubmitResultBase } from '@/types/api';

const TRIGGER_OPT_IN_ENDPOINT = '/api/register/trigger-opt-in';

export const useTriggerOptIn = (registrationId: number, editKey: string) => {
    const url = `${TRIGGER_OPT_IN_ENDPOINT}/${registrationId}/${editKey}`;

    const { submit, isSubmitting, submitError } = useApiSubmit<void, unknown, IApiSubmitResultBase>(
        url,
        () => ({}),
        () => ({}),
        'We were not able to record your response. Please try again.',
    );

    return { trigger: submit, isTriggering: isSubmitting, error: submitError };
};
